var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.457,
    height: 46.653,
    viewBox: "0 0 53.457 46.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history",
    transform: "translate(-19.906 -282)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 44.544,
    height: 46.153,
    rx: 4,
    transform: "translate(19.906 282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 31.674,
    height: 5.325,
    rx: 2.663,
    transform: "translate(27.007 289.1)",
    fill: "#00b893"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 31.674,
    height: 5.325,
    rx: 2.663,
    transform: "translate(27.007 297.976)",
    fill: "#00b893"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 31.674,
    height: 5.325,
    rx: 2.663,
    transform: "translate(27.007 306.852)",
    fill: "#00b893"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 31.674,
    height: 5.325,
    rx: 2.663,
    transform: "translate(27.007 315.727)",
    fill: "#00b893"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_watch_later_24px",
    d: "M14.13,2A12.13,12.13,0,1,0,26.26,14.13,12.166,12.166,0,0,0,14.13,2Zm5.095,17.224-6.308-3.882V8.065h1.819v6.308l.157.094,5.3,3.181-.97,1.577Z",
    transform: "translate(46.604 301.893)",
    fill: "#fff",
    stroke: "#00b893",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.eb974697ba7672c5a6c7ef0743cc9984.svg";
export { ForwardRef as ReactComponent };